import { FC } from "react";

import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { Sidebar } from "shared/ui";
import { SidebarPropsI } from "shared/ui/sidebar";
import { clsxMerge } from "shared/lib/helpers";

import { CircleCommunityIframe } from "./iframe";

interface CircleCommunityIframePropsI extends PropsWithClassNameI {
  communityURL: string;
  urlToDisplay: string;
  closeButton: SidebarPropsI["closeButton"];
  onClose: () => void;
  accessToken?: string;
}

export const CircleCommunitySidebar: FC<CircleCommunityIframePropsI> = ({
  className,
  communityURL,
  urlToDisplay,
  closeButton,
  onClose,
  accessToken,
}) => (
  <Sidebar
    hideTitle
    hideBg
    disableAnimation
    hideCloseIcon
    isOverlayClickable
    className={clsxMerge("relative bg-none p-0", className)}
    headerClassName="p-0 h-0"
    closeButtonClassName="absolute top-5 right-5"
    containerClassName="w-[90vw] shadow-none"
    handleClose={onClose}
    closeButton={closeButton}
  >
    <CircleCommunityIframe
      iframeClassName="absolute left-0 top-0 h-full w-full"
      communityURL={communityURL}
      accessToken={accessToken}
      urlToDisplay={urlToDisplay}
    />
  </Sidebar>
);
